import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/auth';
import { useLanguage } from '@/context/language-context';
import Layout from '@/components/layout/Layout';
import RequireAuth from '@/components/auth/RequireAuth';
import { supabase } from '@/integrations/supabase/client';
import { Button } from '@/components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import ProfileEditForm from '@/components/profile/ProfileEditForm';
import AccountSettingsForm from '@/components/profile/AccountSettingsForm';
import PrivacySettingsForm from '@/components/profile/PrivacySettingsForm';
import SubscriptionSettings from '@/components/profile/SubscriptionSettings';
import { toast } from '@/components/ui/use-toast';

const ProfileManagement: React.FC = () => {
  const { user } = useAuth();
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('profile');
  
  useEffect(() => {
    // Plus besoin d'appeler ensureStorageBuckets ici
    /*
    const initStorage = async () => {
      try {
        await ensureStorageBuckets(); // <-- Supprimer l'appel
      } catch (error) {
        console.error('Failed to initialize storage:', error);
        toast({
          title: t('general.error'),
          description: t('profile.storage_error'),
          variant: 'destructive',
        });
      }
    };
    
    initStorage();
    */
    // Laisser le useEffect vide ou l'utiliser pour autre chose si nécessaire
  }, [t]); // Peut-être supprimer t des dépendances si le useEffect est vide
  
  const handleTabChange = (value: string) => {
    setActiveTab(value);
  };
  
  return (
    <Layout>
      <RequireAuth>
        <div className="container max-w-4xl mx-auto py-8">
          <h1 className="text-3xl font-bold mb-2">{t('profile.account_settings')}</h1>
          <p className="text-muted-foreground mb-6">{t('profile.account_settings_description')}</p>
          
          <Tabs value={activeTab} onValueChange={handleTabChange} className="space-y-6">
            <TabsList className="w-full grid grid-cols-2 md:grid-cols-4">
              <TabsTrigger value="profile">{t('profile.profile')}</TabsTrigger>
              <TabsTrigger value="account">{t('profile.account')}</TabsTrigger>
              <TabsTrigger value="privacy">{t('profile.privacy')}</TabsTrigger>
              <TabsTrigger value="subscription">{t('profile.subscription')}</TabsTrigger>
            </TabsList>
            
            <TabsContent value="profile" className="space-y-6">
              <ProfileEditForm />
            </TabsContent>
            
            <TabsContent value="account" className="space-y-6">
              <AccountSettingsForm />
            </TabsContent>
            
            <TabsContent value="privacy" className="space-y-6">
              <PrivacySettingsForm />
            </TabsContent>
            
            <TabsContent value="subscription" className="space-y-6">
              <SubscriptionSettings />
            </TabsContent>
          </Tabs>
          
          {user?.role === 'escort' && (
            <div className="mt-8 border-t pt-8">
              <h2 className="text-xl font-semibold mb-4">{t('profile.escort_dashboard')}</h2>
              <p className="text-muted-foreground mb-4">{t('profile.escort_dashboard_description')}</p>
              <Button onClick={() => navigate('/escort-dashboard')}>
                {t('profile.go_to_escort_dashboard')}
              </Button>
            </div>
          )}
        </div>
      </RequireAuth>
    </Layout>
  );
};

export default ProfileManagement;
